import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        opacity="0.4"
        d="M43.4199 9.25C36.5899 0.539997 26.7799 0.350009 24.6799 0.450009C22.5799 0.360009 12.4499 0.299997 5.93994 9.25C-2.24006 20.5 0.509944 44.83 0.509944 44.83C0.509944 44.83 3.98995 37.6 5.10995 21.49C5.32995 18.29 7.56994 13.46 10.4199 12.46C14.4699 11.05 19.7299 13.01 24.6799 13.01C29.2299 13.01 34.2099 11.38 38.1699 12.46C41.5399 13.37 43.8599 16.85 44.2499 21.07C45.7299 36.96 49.0699 45.15 49.0699 45.15C49.0699 45.15 52.1499 20.39 43.4199 9.25Z"
        fill={fill}
      />
    </g>
  )
}
